/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("./CreateComponent");
const _ = require("lodash");

class CreateAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        OdmOsPlatform,
        userSession,
        activeView,
        ValueMap
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._odmOsPlatform = new OdmOsPlatform(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._ValueMap = ValueMap;
        this._activeOrgId = userSession.activeOrganization.id;
        this.run = this.run.bind(this);
    }

    run() {
        // Load ValueMap to get field options for dropdowns
        return this._ValueMap
            .loadValueMapByName(this._activeOrgId, "xdome")
            .then((vendorOsMapEntity) => {
                const fieldMappings = vendorOsMapEntity.valueMap;
                const fieldOptions = this._generateFieldOptions(fieldMappings);

                const createComponent = new CreateComponent(
                    this._logger,
                    this._odmOsPlatform,
                    null,
                    fieldOptions
                );

                return this._modalUserFeedback.displayCustom(createComponent, {dontHide: true});
            })
            .then((data) => {
                // Success - hide modal and launch editor
                this._modalUserFeedback.hideDisplayed();

                let editorState = {
                    fqn: Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_DETAILS,
                    viewState: {createMode: true},
                };
                let launchOpts = {
                    id: data.id,
                    title: data.result.properties.name,
                };

                this._gameEditor.launchOdmOsPlatformEditor(editorState, launchOpts);

                if (
                    typeof this._activeView.resetSelection === "function" &&
                    typeof this._activeView.loadAndScrollTo === "function"
                ) {
                    this._activeView.resetSelection([data.id]);
                    this._activeView.loadAndScrollTo(data.id);
                }

                return data.result;
            })
            .catch((err) => {
                // User cancelled
                this._modalUserFeedback.hideDisplayed();
                if (!err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "CreateAction.run() - Error during dialog display"
                    );
                }
            });
    }

    _generateFieldOptions(fieldMappings) {
        const {deviceType, manufacturer, model} = fieldMappings;
        return {
            deviceTypeOpts: this._generateOptionsForField(deviceType),
            manufacturerOpts: this._generateOptionsForField(manufacturer),
            modelOpts: this._generateOptionsForField(model),
        };
    }

    _generateOptionsForField(fieldMapObj) {
        if (!fieldMapObj) {
            return [];
        }
        return Object.keys(fieldMapObj)
            .filter((key) => fieldMapObj[key])
            .map((key) => ({
                label: key,
                value: key,
            }));
    }
}

module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OdmOsPlatform",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.entities.ValueMap",
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "osmanager.add_platform",
    shown: true,
    title: "Add IoT Platform",
    order: 1,
};
